export function getBrowserLanguage(){
  var nav = window.navigator,
  browserLanguagePropertyKeys = ['language', 'browserLanguage', 'systemLanguage', 'userLanguage'],
  i,
  language;

  // support for HTML 5.1 "navigator.languages"
  if (Array.isArray(nav.languages)) {
    for (i = 0; i < nav.languages.length; i++) {
      language = nav.languages[i];
      if (language && language.length) {
        return language;
      }
    }
  }

  // support for other well known properties in browsers
  for (i = 0; i < browserLanguagePropertyKeys.length; i++) {
    language = nav[browserLanguagePropertyKeys[i]];
    if (language && language.length) {
      return language;
    }
  }

  return null;
}


export function getParameterByName(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

export function browserNeeded(){
  let userAgent = navigator.userAgent.toLowerCase();
  if(userAgent.indexOf("iphone") > -1 || userAgent.indexOf("ipad") > -1){
    return "safari";
  }
  else{
    return "chrome";
  }
}

export function deviceOS(){
  let userAgent = navigator.userAgent.toLowerCase();
  if(userAgent.indexOf("iphone") > -1 || userAgent.indexOf("ipad") > -1){
    return "IOS";
  }
  else{
    return "AOS";
  }
}

export function stringLength(c){
  var n=c.length,s;
  var len=0;
  for(var i=0; i <n;i++){
   s=c.charCodeAt(i);
   while( s > 0 ){
      len++;
      s = s >> 8;
   }
  }
  return len;
}


// calculate whether in area
export function insideArea(point, vs) {
  var x = point[0], y = point[1];
  var inside = false;
  for (var i = 0, j = vs.length - 1; i < vs.length; j = i++) {
      var xi = vs[i][0], yi = vs[i][1];
      var xj = vs[j][0], yj = vs[j][1];

      var intersect = ((yi > y) != (yj > y))
          && (x < (xj - xi) * (y - yi) / (yj - yi) + xi);
      if (intersect) inside = !inside;
  }
  return inside;
}




export function checkSupportBrowser(){
  let isSupportBrowser = false;
  console.log("Check Browser");
  let userAgent = navigator.userAgent.toLowerCase();
  console.log(userAgent);
  if(userAgent.indexOf("iphone") > -1 && userAgent.indexOf("safari") > -1 && userAgent.indexOf("crios") == -1 && userAgent.indexOf("fxios") == -1){
    isSupportBrowser = true;
  }
  else if(userAgent.indexOf("android") > -1 && userAgent.indexOf("chrome") > -1){
    isSupportBrowser = true;
  }
  if(userAgent.indexOf("firefox") > -1){
    isSupportBrowser = false;
  }
  if(userAgent.indexOf("ucbrowser") > -1){
    isSupportBrowser = false;
  }
  if(userAgent.indexOf("hawk") > -1){
    isSupportBrowser = false;
  }
  if(userAgent.indexOf("mqqbrowser") > -1){
    isSupportBrowser = false;
  }
  if(userAgent.indexOf("baiduboxapp") > -1){
    isSupportBrowser = false;
  }
  if(userAgent.indexOf("acheetahi") > -1){
    isSupportBrowser = false;
  }
  if(userAgent.indexOf("opr") > -1){
    isSupportBrowser = false;
  }
  if(userAgent.indexOf("samsungbrowser") > -1){
    isSupportBrowser = false;
  }
  if(userAgent.indexOf("micromessager") > -1){
    isSupportBrowser = false;
  }
  if(userAgent.indexOf("fban") > -1){
    isSupportBrowser = false;
  }
  if(userAgent.indexOf("sogoumobilebrowser") > -1){
    isSupportBrowser = false;
  }
  if(userAgent.indexOf("mb2345browser") > -1){
    isSupportBrowser = false;
  }
  if(userAgent.indexOf("wv") > -1){
    isSupportBrowser = false;
  }
  return isSupportBrowser;
}



//計兩個 point X Y 相差位置 ，Distance
//reference
//https://www.igismap.com/formula-to-find-bearing-or-heading-angle-between-two-points-latitude-longitude/
//https://www.geodatasource.com/developers/javascript
export function twoPointInfo(latStart, lonStart, latEnd, lonEnd) {
  var x = Math.cos(latEnd) * Math.sin(lonStart - lonEnd);
  var z = Math.cos(latStart) * Math.sin(latEnd) - Math.sin(latStart) * Math.cos(latEnd) * Math.cos(lonStart - lonEnd);
  var dist;
  if ((latStart == latEnd) && (lonStart == lonEnd)) {
    dist= 0;
  }
  else {
    var radlat1 = Math.PI * latStart/180;
    var radlat2 = Math.PI * latEnd/180;
    var theta = lonStart-lonEnd;
    var radtheta = Math.PI * theta/180;
    var dist = Math.sin(radlat1) * Math.sin(radlat2) + Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
    if (dist > 1) {
      dist = 1;
    }
    dist = Math.acos(dist);
    dist = dist * 180/Math.PI;
    dist = dist * 60 * 1.1515;
    dist = dist * 1.609344;
  }
  //唔知點解 100000 , 但好似啱 試出黎
  return {"x":x*100000,"z":z*100000,"distance":parseFloat((dist*1000).toFixed(2))};
}


export function calcXYDistance(x1, y1, x2, y2) {
  return Math.sqrt( (Math.pow((x1 - x2) ,2)) + (Math.pow((y1 - y2),2)) );
}


//sorting JSON
export function sortJSON(data, key, way) {
    return data.sort(function(a, b) {
        var x = a[key]; var y = b[key];
        if (way === 'small' ) { return ((x < y) ? -1 : ((x > y) ? 1 : 0)); }
        if (way === 'large') { return ((x > y) ? -1 : ((x < y) ? 1 : 0)); }
    });
}

export function calAngle(cx, cy, ex, ey) {
  var dy = ey - cy;
  var dx = ex - cx;
  var theta = Math.atan2(dy, dx); // range (-PI, PI]
  theta *= 180 / Math.PI; // rads to degs, range (-180, 180]
  //if (theta < 0) theta = 360 + theta; // range [0, 360)
  return theta;
}

export const MERCATOR = {
  fromLatLngToPoint: function(latLng){
    var siny = Math.min(
      Math.max(
        Math.sin(latLng.lat * (Math.PI / 180)),
        -.9999
      ),
      .9999
    );
    return {
      x: 128 + latLng.lon * (256/360),
      y: 128 + 0.5 * Math.log((1 + siny) / (1 - siny)) * - (256 / (2 * Math.PI))
    };
  },

  fromPointToLatLng: function(point){
    return {
      lat: (2 * Math.atan(Math.exp((point.y - 128) / -(256 / (2 * Math.PI)))) - Math.PI / 2)/ (Math.PI / 180),
      lng: (point.x - 128) / (256 / 360)
    };

  },
  getTileAtLatLng: function(latLng, zoom){
    var
      t = Math.pow(2, zoom),
      s = 256/t,
      p = this.fromLatLngToPoint(latLng)
    ;
    return {
      x: Math.floor(p.x/s),
      y: Math.floor(p.y/s),
      z: zoom
    };
  },
  getTileBounds: function(tile){
    tile = this.normalizeTile(tile);
    var
      t = Math.pow(2, tile.z),
      s = 256/t,
      sw = {
        x: tile.x*s,
        y: (tile.y*s) + s
      },
      ne = {
        x: tile.x*s + s,
        y: (tile.y*s)
      }
    ;
    return {
      sw: this.fromPointToLatLng(sw),
      ne: this.fromPointToLatLng(ne)
    };
  },
  normalizeTile: function(tile){
    var t = Math.pow(2, tile.z);
    tile.x = ((tile.x%t)+t)%t;
    tile.y = ((tile.y%t)+t)%t;
    return tile;
  }
}

export function setCookie(cname, cvalue, exdays) {
  const d = new Date();
  d.setTime(d.getTime() + (exdays*24*60*60*1000));
  let expires = "expires="+ d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

export function getCookie(cname) {
  let name = cname + "=";
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(';');
  for(let i = 0; i <ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

export function deleteAllCookies() {
  var cookies = document.cookie.split(";");
  for (var i = 0; i < cookies.length; i++) {
      var cookie = cookies[i];
      var eqPos = cookie.indexOf("=");
      var name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
      document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
  }
}



export function calculateProcessingPercentage(value, start, end){
  if(start < end){
    let thisProcessingPercentage = (value - start) / (end - start);
    return thisProcessingPercentage;
  }
  else{
    let thisProcessingPercentage = (value - end) / (start - end);
    return thisProcessingPercentage;
  }
  
}

export function calculateFromToValueWithPercentage(from , to , percentage){
  if(from < to){
    return percentage * (to - from) + from;
  }
  else{
    return (1- percentage) * (from - to) + to;
  }
}

export function setLeft(element, from , to , percentage , unit = "%", roundUp = 10){
  if(element != null){
    let processingLeft;
    if(from < to){
      processingLeft = percentage * (to - from) + from;
    }
    else{
      processingLeft = (1- percentage) * (from - to) + to;
    }
    processingLeft = Math.round(processingLeft * roundUp) / roundUp;
    element.style.left = processingLeft + unit;
  }
}

export function setActualLeft(element, left , unit = "%"){
  if(element != null){
    element.style.left = left + unit;
  }
}

export function setRight(element, from , to , percentage , unit = "%"){
  if(element != null){
    if(from < to){
      element.style.right = percentage * (to - from) + from + unit;
    }
    else{
      element.style.right = (1- percentage) * (from - to) + to + unit;
    }
  }
}

export function setActualRight(element, right , unit = "%"){
  if(element != null){
    element.style.right = right + unit;
  }
}


export function strip(number) {
  return (parseFloat(number).toPrecision(12));
}

export function applyElementValue(element, style, initFrame,  data, value, progress, unit = "%", roundUp = 10){

  let isApplyValue = true;
  
  if(element == null){
    isApplyValue = false;
  }
  else{
    if(style != "opacity"){
      if(element.style.display == "none"){

        if(data.length >= 2){
          let startFrame = progress[initFrame];
          let endFrame = progress[ (initFrame + (data.length - 2))];

          if(value - startFrame < -1000){
            isApplyValue = false;
          }
          if(value - endFrame > 1000){
            isApplyValue = false;
          }

        }
      }
    }
  }

  
  if(isApplyValue){
    for(let dataLoop = 0 ; dataLoop < data.length; dataLoop ++){
      //let checkingFrame = initFrame + data[dataLoop]["frame"];
      
      let checkingFrame = Math.round(strip(initFrame + data[dataLoop]["frame"]) * 10) / 10;

      if(checkingFrame){
        let checkingValue = progress[checkingFrame];

        if(checkingValue){
          if(value <= checkingValue){

            if(data[dataLoop]["direct"]){
              if(style == "top"){ 
                setActualTop(element,data[dataLoop]["value"],unit);
              }
              else if(style == "bottom"){ 
                setActualBottom(element,data[dataLoop]["value"],unit);
              }
              else if(style == "left"){
                setActualLeft(element,data[dataLoop]["value"],unit);
              }
              else if(style == "right"){
                setActualRight(element,data[dataLoop]["value"],unit);
              }
              else if(style == "width"){
                setActualWidth(element,data[dataLoop]["value"],unit);
              }
              else if(style == "height"){
                setActualHeight(element,data[dataLoop]["value"],unit);
              }
              else if(style == "blur"){
                setActualBlur(element,data[dataLoop]["value"]);
              }
              else if(style == "opacity"){
                setActualOpacity(element,data[dataLoop]["value"]);
              }
              else if(style == "backgroundColor"){
                setActualBackgroundColor(element,data[dataLoop]["value"]);
              }
              else if(style == "rotation"){
                setActualRotation(element,data[dataLoop]["value"]);
              }
              else if(style == "rotationCenter"){
                setActualRotationCenter(element,data[dataLoop]["value"]);
              }
              else if(style == "scale"){
                setActualScale(element,data[dataLoop]["value"]);
              }
              else if(style == "transform"){
                setActualTransform(element,data[dataLoop]["value"]);
              }
            }
            else{

              let fromFrame = Math.round(strip(initFrame + data[dataLoop - 1]["frame"]) * 10) / 10;
              let toFrame = Math.round(strip(initFrame + data[dataLoop]["frame"]) * 10) / 10;

              
            

              let thisProcessingPercentage = calculateProcessingPercentage(value,progress[fromFrame],progress[toFrame]);

              if(style == "top"){
                setTop(element,data[dataLoop]["from"],data[dataLoop]["to"],thisProcessingPercentage,unit,roundUp);
              }
              else if(style == "bottom"){
                setBottom(element,data[dataLoop]["from"],data[dataLoop]["to"],thisProcessingPercentage,unit, roundUp);
              }
              else if(style == "left"){
                setLeft(element,data[dataLoop]["from"],data[dataLoop]["to"],thisProcessingPercentage,unit, roundUp);
              }
              else if(style == "right"){
                setRight(element,data[dataLoop]["from"],data[dataLoop]["to"],thisProcessingPercentage,unit);
              }
              else if(style == "width"){
                setWidth(element,data[dataLoop]["from"],data[dataLoop]["to"],thisProcessingPercentage,unit);
              }
              else if(style == "height"){
                setHeight(element,data[dataLoop]["from"],data[dataLoop]["to"],thisProcessingPercentage,unit, roundUp);
              }
              else if(style == "blur"){
                setBlur(element,data[dataLoop]["from"],data[dataLoop]["to"],thisProcessingPercentage,unit);
              }
              else if(style == "opacity"){
                setOpacity(element,data[dataLoop]["from"],data[dataLoop]["to"],thisProcessingPercentage,unit,roundUp);
              }
              else if(style == "backgroundColor"){
                setBackgroundColor(element,data[dataLoop]["from"],data[dataLoop]["to"],thisProcessingPercentage);
              }
              else if(style == "rotation"){
                setRotation(element,data[dataLoop]["from"],data[dataLoop]["to"],thisProcessingPercentage, unit, roundUp);
              }
              else if(style == "rotationCenter"){
                setRotationCenter(element,data[dataLoop]["from"],data[dataLoop]["to"],thisProcessingPercentage);
              }
              else if(style == "scale"){
                
                setScale(element,data[dataLoop]["from"],data[dataLoop]["to"],thisProcessingPercentage);
              }
              else if(style == "transform"){
                setTransform(element,data[dataLoop]["from"],data[dataLoop]["to"],thisProcessingPercentage);
              }
            }
            break;
          }
        }
      }
      else{
        if(style == "top"){
          setActualTop(element,data[dataLoop]["value"],unit);
        }
        else if(style == "bottom"){
          setActualBottom(element,data[dataLoop]["value"],unit);
        }
        else if(style == "left"){ 
          setActualLeft(element,data[dataLoop]["value"],unit);
        }
        else if(style == "right"){ 
          setActualRight(element,data[dataLoop]["value"],unit);
        }
        else if(style == "width"){
          setActualWidth(element,data[dataLoop]["value"],unit);
        }
        else if(style == "height"){
          setActualHeight(element,data[dataLoop]["value"],unit);
        }
        else if(style == "blur"){
          setActualBlur(element,data[dataLoop]["value"],unit);
        }
        else if(style == "opacity"){
          setActualOpacity(element,data[dataLoop]["value"],unit);
        }
        else if(style == "backgroundColor"){
          setActualBackgroundColor(element,data[dataLoop]["value"]);
        }
        else if(style == "rotation"){
          setActualRotation(element,data[dataLoop]["value"]);
        }
        else if(style == "rotationCenter"){
          setActualRotationCenter(element,data[dataLoop]["value"]);
        }
        else if(style == "scale"){
          setActualScale(element,data[dataLoop]["value"]);
        }
        else if(style == "transform"){
          setActualTransform(element,data[dataLoop]["value"]);
        }
      }
    }
  }
}

export function applyElementValuePercentage(element, style, data, currentPercentage, unit = "%", roundUp = 10){



  for(let dataLoop = 0 ; dataLoop < data.length; dataLoop ++){

    let checkingStage = data[dataLoop]["frame"];
    
    if(checkingStage != null){
      if(checkingStage >= currentPercentage){
        if(data[dataLoop]["direct"]){
          if(style == "top"){ 
            setActualTop(element,data[dataLoop]["value"],unit);
          }
          else if(style == "bottom"){ 
            setActualBottom(element,data[dataLoop]["value"],unit);
          }
          else if(style == "left"){
            setActualLeft(element,data[dataLoop]["value"],unit);
          }
          else if(style == "right"){
            setActualRight(element,data[dataLoop]["value"],unit);
          }
          else if(style == "width"){
            setActualWidth(element,data[dataLoop]["value"],unit);
          }
          else if(style == "height"){
            setActualHeight(element,data[dataLoop]["value"],unit);
          }
          else if(style == "blur"){
            setActualBlur(element,data[dataLoop]["value"]);
          }
          else if(style == "opacity"){
            setActualOpacity(element,data[dataLoop]["value"]);
          }
          else if(style == "backgroundColor"){
            setActualBackgroundColor(element,data[dataLoop]["value"]);
          }
          else if(style == "rotation"){
            setActualRotation(element,data[dataLoop]["value"]);
          }
          else if(style == "rotationCenter"){
            setActualRotationCenter(element,data[dataLoop]["value"]);
          }
          else if(style == "scale"){
            setActualScale(element,data[dataLoop]["value"]);
          }
          else if(style == "transform"){
            setActualTransform(element,data[dataLoop]["value"]);
          }
        }
        else{
          let fromFrame = data[dataLoop - 1]["frame"];
          let toFrame = data[dataLoop]["frame"];
          let thisProcessingPercentage = calculateProcessingPercentage(currentPercentage,fromFrame,toFrame);
          
          if(style == "top"){
            setTop(element,data[dataLoop]["from"],data[dataLoop]["to"],thisProcessingPercentage,unit,roundUp);
          }
          else if(style == "bottom"){
            setBottom(element,data[dataLoop]["from"],data[dataLoop]["to"],thisProcessingPercentage,unit, roundUp);
          }
          else if(style == "left"){
            setLeft(element,data[dataLoop]["from"],data[dataLoop]["to"],thisProcessingPercentage,unit, roundUp);
          }
          else if(style == "right"){
            setRight(element,data[dataLoop]["from"],data[dataLoop]["to"],thisProcessingPercentage,unit);
          }
          else if(style == "width"){
            setWidth(element,data[dataLoop]["from"],data[dataLoop]["to"],thisProcessingPercentage,unit);
          }
          else if(style == "height"){
            setHeight(element,data[dataLoop]["from"],data[dataLoop]["to"],thisProcessingPercentage,unit, roundUp);
          }
          else if(style == "blur"){
            setBlur(element,data[dataLoop]["from"],data[dataLoop]["to"],thisProcessingPercentage,unit);
          }
          else if(style == "opacity"){
            setOpacity(element,data[dataLoop]["from"],data[dataLoop]["to"],thisProcessingPercentage,unit,roundUp);
          }
          else if(style == "backgroundColor"){
            setBackgroundColor(element,data[dataLoop]["from"],data[dataLoop]["to"],thisProcessingPercentage);
          }
          else if(style == "rotation"){
            setRotation(element,data[dataLoop]["from"],data[dataLoop]["to"],thisProcessingPercentage, unit, roundUp);
          }
          else if(style == "rotationCenter"){
            setRotationCenter(element,data[dataLoop]["from"],data[dataLoop]["to"],thisProcessingPercentage);
          }
          else if(style == "scale"){
            
            setScale(element,data[dataLoop]["from"],data[dataLoop]["to"],thisProcessingPercentage);
          }
          else if(style == "transform"){
            setTransform(element,data[dataLoop]["from"],data[dataLoop]["to"],thisProcessingPercentage);
          }

        }
        break;
      }
      
    }
    else{
      if(style == "top"){ 
        setActualTop(element,data[dataLoop]["value"],unit);
      }
      else if(style == "bottom"){ 
        setActualBottom(element,data[dataLoop]["value"],unit);
      }
      else if(style == "left"){
        setActualLeft(element,data[dataLoop]["value"],unit);
      }
      else if(style == "right"){
        setActualRight(element,data[dataLoop]["value"],unit);
      }
      else if(style == "width"){
        setActualWidth(element,data[dataLoop]["value"],unit);
      }
      else if(style == "height"){
        setActualHeight(element,data[dataLoop]["value"],unit);
      }
      else if(style == "blur"){
        setActualBlur(element,data[dataLoop]["value"]);
      }
      else if(style == "opacity"){
        setActualOpacity(element,data[dataLoop]["value"]);
      }
      else if(style == "backgroundColor"){
        setActualBackgroundColor(element,data[dataLoop]["value"]);
      }
      else if(style == "rotation"){
        setActualRotation(element,data[dataLoop]["value"]);
      }
      else if(style == "rotationCenter"){
        setActualRotationCenter(element,data[dataLoop]["value"]);
      }
      else if(style == "scale"){
        setActualScale(element,data[dataLoop]["value"]);
      }
      else if(style == "transform"){
        setActualTransform(element,data[dataLoop]["value"]);
      }
      break;
    }
    

    // if(checkingFrame){
    //   let checkingValue = progress[checkingFrame];

    //   if(checkingValue){
    //     if(value <= checkingValue){

    //       if(data[dataLoop]["direct"]){
    //         if(style == "top"){ 
    //           setActualTop(element,data[dataLoop]["value"],unit);
    //         }
    //         else if(style == "bottom"){ 
    //           setActualBottom(element,data[dataLoop]["value"],unit);
    //         }
    //         else if(style == "left"){
    //           setActualLeft(element,data[dataLoop]["value"],unit);
    //         }
    //         else if(style == "right"){
    //           setActualRight(element,data[dataLoop]["value"],unit);
    //         }
    //         else if(style == "width"){
    //           setActualWidth(element,data[dataLoop]["value"],unit);
    //         }
    //         else if(style == "height"){
    //           setActualHeight(element,data[dataLoop]["value"],unit);
    //         }
    //         else if(style == "blur"){
    //           setActualBlur(element,data[dataLoop]["value"]);
    //         }
    //         else if(style == "opacity"){
    //           setActualOpacity(element,data[dataLoop]["value"]);
    //         }
    //         else if(style == "backgroundColor"){
    //           setActualBackgroundColor(element,data[dataLoop]["value"]);
    //         }
    //         else if(style == "rotation"){
    //           setActualRotation(element,data[dataLoop]["value"]);
    //         }
    //         else if(style == "rotationCenter"){
    //           setActualRotationCenter(element,data[dataLoop]["value"]);
    //         }
    //         else if(style == "scale"){
    //           setActualScale(element,data[dataLoop]["value"]);
    //         }
    //         else if(style == "transform"){
    //           setActualTransform(element,data[dataLoop]["value"]);
    //         }
    //       }
    //       else{

    //         let fromFrame = Math.round(strip(initFrame + data[dataLoop - 1]["frame"]) * 10) / 10;
    //         let toFrame = Math.round(strip(initFrame + data[dataLoop]["frame"]) * 10) / 10;

            
          

    //         let thisProcessingPercentage = calculateProcessingPercentage(value,progress[fromFrame],progress[toFrame]);

    //         if(style == "top"){
    //           setTop(element,data[dataLoop]["from"],data[dataLoop]["to"],thisProcessingPercentage,unit,roundUp);
    //         }
    //         else if(style == "bottom"){
    //           setBottom(element,data[dataLoop]["from"],data[dataLoop]["to"],thisProcessingPercentage,unit, roundUp);
    //         }
    //         else if(style == "left"){
    //           setLeft(element,data[dataLoop]["from"],data[dataLoop]["to"],thisProcessingPercentage,unit, roundUp);
    //         }
    //         else if(style == "right"){
    //           setRight(element,data[dataLoop]["from"],data[dataLoop]["to"],thisProcessingPercentage,unit);
    //         }
    //         else if(style == "width"){
    //           setWidth(element,data[dataLoop]["from"],data[dataLoop]["to"],thisProcessingPercentage,unit);
    //         }
    //         else if(style == "height"){
    //           setHeight(element,data[dataLoop]["from"],data[dataLoop]["to"],thisProcessingPercentage,unit, roundUp);
    //         }
    //         else if(style == "blur"){
    //           setBlur(element,data[dataLoop]["from"],data[dataLoop]["to"],thisProcessingPercentage,unit);
    //         }
    //         else if(style == "opacity"){
    //           setOpacity(element,data[dataLoop]["from"],data[dataLoop]["to"],thisProcessingPercentage,unit,roundUp);
    //         }
    //         else if(style == "backgroundColor"){
    //           setBackgroundColor(element,data[dataLoop]["from"],data[dataLoop]["to"],thisProcessingPercentage);
    //         }
    //         else if(style == "rotation"){
    //           setRotation(element,data[dataLoop]["from"],data[dataLoop]["to"],thisProcessingPercentage, unit, roundUp);
    //         }
    //         else if(style == "rotationCenter"){
    //           setRotationCenter(element,data[dataLoop]["from"],data[dataLoop]["to"],thisProcessingPercentage);
    //         }
    //         else if(style == "scale"){
              
    //           setScale(element,data[dataLoop]["from"],data[dataLoop]["to"],thisProcessingPercentage);
    //         }
    //         else if(style == "transform"){
    //           setTransform(element,data[dataLoop]["from"],data[dataLoop]["to"],thisProcessingPercentage);
    //         }
    //       }
    //       break;
    //     }
    //   }
    // }
    // else{
    //   if(style == "top"){
    //     setActualTop(element,data[dataLoop]["value"],unit);
    //   }
    //   else if(style == "bottom"){
    //     setActualBottom(element,data[dataLoop]["value"],unit);
    //   }
    //   else if(style == "left"){ 
    //     setActualLeft(element,data[dataLoop]["value"],unit);
    //   }
    //   else if(style == "right"){ 
    //     setActualRight(element,data[dataLoop]["value"],unit);
    //   }
    //   else if(style == "width"){
    //     setActualWidth(element,data[dataLoop]["value"],unit);
    //   }
    //   else if(style == "height"){
    //     setActualHeight(element,data[dataLoop]["value"],unit);
    //   }
    //   else if(style == "blur"){
    //     setActualBlur(element,data[dataLoop]["value"],unit);
    //   }
    //   else if(style == "opacity"){
    //     setActualOpacity(element,data[dataLoop]["value"],unit);
    //   }
    //   else if(style == "backgroundColor"){
    //     setActualBackgroundColor(element,data[dataLoop]["value"]);
    //   }
    //   else if(style == "rotation"){
    //     setActualRotation(element,data[dataLoop]["value"]);
    //   }
    //   else if(style == "rotationCenter"){
    //     setActualRotationCenter(element,data[dataLoop]["value"]);
    //   }
    //   else if(style == "scale"){
    //     setActualScale(element,data[dataLoop]["value"]);
    //   }
    //   else if(style == "transform"){
    //     setActualTransform(element,data[dataLoop]["value"]);
    //   }
    // }
  }
}



export function applyElementValueBackup(element, style , data, value, progress, unit = "%", roundUp = 10){

  let isApplyValue = true;
  let startFrame = progress[data[0]["frame"]];
  let endFrame = progress[data[ data.length - 1 ]["frame"]];
  if(!endFrame && data.length >= 2){
    endFrame = progress[data[ data.length - 2 ]["frame"]];
  }
  if(isApplyValue){
    for(let dataLoop = 0 ; dataLoop < data.length; dataLoop ++){
      let checkingFrame = data[dataLoop]["frame"];


      if(checkingFrame){
        let checkingValue = progress[checkingFrame];
        if(checkingValue){
          if(value < checkingValue){
            if(data[dataLoop]["direct"]){
              if(style == "top"){ 
                setActualTop(element,data[dataLoop]["value"],unit);
              }
              else if(style == "bottom"){ 
                setActualBottom(element,data[dataLoop]["value"],unit);
              }
              else if(style == "left"){
                setActualLeft(element,data[dataLoop]["value"],unit);
              }
              else if(style == "right"){
                setActualRight(element,data[dataLoop]["value"],unit);
              }
              else if(style == "width"){
                setActualWidth(element,data[dataLoop]["value"],unit);
              }
              else if(style == "height"){
                setActualHeight(element,data[dataLoop]["value"],unit);
              }
              else if(style == "blur"){
                setActualBlur(element,data[dataLoop]["value"]);
              }
              else if(style == "opacity"){
                setActualOpacity(element,data[dataLoop]["value"]);
              }
              else if(style == "backgroundColor"){
                setActualBackgroundColor(element,data[dataLoop]["value"]);
              }
              else if(style == "rotation"){
                setActualRotation(element,data[dataLoop]["value"]);
              }
              else if(style == "scale"){
                setActualScale(element,data[dataLoop]["value"]);
              }
              else if(style == "transform"){
                setActualTransform(element,data[dataLoop]["value"]);
              }
            }
            else{
              let thisProcessingPercentage = calculateProcessingPercentage(value,progress[data[dataLoop - 1]["frame"]],progress[data[dataLoop]["frame"]]);
              if(style == "top"){
                setTop(element,data[dataLoop]["from"],data[dataLoop]["to"],thisProcessingPercentage,unit,roundUp);
              }
              else if(style == "bottom"){
                setBottom(element,data[dataLoop]["from"],data[dataLoop]["to"],thisProcessingPercentage,unit,roundUp);
              }
              else if(style == "left"){
                setLeft(element,data[dataLoop]["from"],data[dataLoop]["to"],thisProcessingPercentage,unit,roundUp);
              }
              else if(style == "right"){
                setRight(element,data[dataLoop]["from"],data[dataLoop]["to"],thisProcessingPercentage,unit);
              }
              else if(style == "width"){
                setWidth(element,data[dataLoop]["from"],data[dataLoop]["to"],thisProcessingPercentage,unit);
              }
              else if(style == "height"){
                setHeight(element,data[dataLoop]["from"],data[dataLoop]["to"],thisProcessingPercentage,unit,roundUp);
              }
              else if(style == "blur"){
                setBlur(element,data[dataLoop]["from"],data[dataLoop]["to"],thisProcessingPercentage,unit);
              }
              else if(style == "opacity"){
                setOpacity(element,data[dataLoop]["from"],data[dataLoop]["to"],thisProcessingPercentage,unit);
              }
              else if(style == "backgroundColor"){
                setBackgroundColor(element,data[dataLoop]["from"],data[dataLoop]["to"],thisProcessingPercentage);
              }
              else if(style == "rotation"){
                setRotation(element,data[dataLoop]["from"],data[dataLoop]["to"],thisProcessingPercentage,  unit, roundUp);
              }
              else if(style == "scale"){
                setScale(element,data[dataLoop]["from"],data[dataLoop]["to"],thisProcessingPercentage);
              }
              else if(style == "transform"){
                setTransform(element,data[dataLoop]["from"],data[dataLoop]["to"],thisProcessingPercentage);
              }
            }
            break;
          }
        }
      }
      else{
        if(style == "top"){
          setActualTop(element,data[dataLoop]["value"],unit);
        }
        else if(style == "bottom"){
          setActualBottom(element,data[dataLoop]["value"],unit);
        }
        else if(style == "left"){ 
          setActualLeft(element,data[dataLoop]["value"],unit);
        }
        else if(style == "right"){ 
          setActualRight(element,data[dataLoop]["value"],unit);
        }
        else if(style == "width"){
          setActualWidth(element,data[dataLoop]["value"],unit);
        }
        else if(style == "height"){
          setActualHeight(element,data[dataLoop]["value"],unit);
        }
        else if(style == "blur"){
          setActualBlur(element,data[dataLoop]["value"],unit);
        }
        else if(style == "opacity"){
          setActualOpacity(element,data[dataLoop]["value"],unit);
        }
        else if(style == "backgroundColor"){
          setActualBackgroundColor(element,data[dataLoop]["value"]);
        }
        else if(style == "rotation"){
          setActualRotation(element,data[dataLoop]["value"]);
        }
        else if(style == "scale"){
          setActualScale(element,data[dataLoop]["value"]);
        }
        else if(style == "transform"){
          setActualTransform(element,data[dataLoop]["value"]);
        }
      }
    }
  }
}

export function setTop(element, from , to , percentage ,unit = "%" , roundUp = 10){
  if(element != null){
    let processingTop;
    if(from < to){
      processingTop = percentage * (to - from) + from;
    }
    else{
      processingTop = (1- percentage) * (from - to) + to;
    }
    processingTop = Math.round(processingTop * roundUp) / roundUp;
    element.style.top = processingTop + unit;
  }
}

export function setActualTop(element, top,  unit = "%"){
  if(element != null){
    if(element.style.top != top + unit){
      element.style.top = top + unit;
    }
  }
}

export function setBottom(element, from , to , percentage ,unit = "%", roundUp){
  if(element != null){
    let processingBottom;
    if(from < to){
      processingBottom = percentage * (to - from) + from;
    }
    else{
      processingBottom = (1- percentage) * (from - to) + to;
    }
    processingBottom = Math.round(processingBottom * roundUp) / roundUp;
    element.style.bottom = processingBottom + unit;
  }
}

export function setActualBottom(element, bottom,  unit = "%"){
  if(element != null){
    element.style.bottom = bottom + unit;
  }
}

export function setHeight(element, from , to , percentage, unit = "%" , roundUp){
  if(element != null){
    let processingHeight;
    if(from < to){
      processingHeight = percentage * (to - from) + from;
    }
    else{
      processingHeight = (1- percentage) * (from - to) + to;
    }
    processingHeight = Math.round(processingHeight * roundUp) / roundUp;
    element.style.height = processingHeight + unit;
  }
}

export function setActualHeight(element, height, unit = "%"){
  if(element != null){
    element.style.height = height + unit;
  }
}

export function setWidth(element, from , to , percentage, unit = "%"){
  if(element != null){
    let processingWidth;
    if(from < to){
      processingWidth = percentage * (to - from) + from;
    }
    else{
      processingWidth = (1- percentage) * (from - to) + to;
    }
    processingWidth = Math.round(processingWidth * 10) / 10;
    element.style.width = processingWidth + unit;
  }
}

export function setActualWidth(element, width, unit = "%"){
  if(element != null){
    element.style.width = width + unit;
  }
}

export function setPaddingTop(element, from , to , percentage, unit = "%"){
  if(element != null){
    if(from < to){
      element.style.paddingTop = percentage * (to - from) + from + unit;
    }
    else{
      element.style.paddingTop = (1- percentage) * (from - to) + to + unit;
    }
  }
}

export function setActualPaddingTop(element, paddingTop, unit = "%"){
  if(element != null){
    element.style.paddingTop = paddingTop + unit;
  }
}

export function setScale(element, from, to, percentage){
  if(element != null){
    let fromData = from.split(" ");let toData = to.split(" ");
    let fromX = parseFloat(fromData[0]);
    let fromY = parseFloat(fromData[1]);
    let fromZ = parseFloat(fromData[2]);
    let toX = parseFloat(toData[0]);let toY = parseFloat(toData[1]);let toZ = parseFloat(toData[2]);

    let processingX = fromX;
    let processingY = fromY;
    let processingZ = fromZ;

    if(fromX < toX){
      processingX = percentage * (toX - fromX) + fromX;
    }
    else{
      processingX = (1 - percentage) * (fromX - toX) + toX;
    }

    if(fromY < toY){
      processingY = percentage * (toY - fromY) + fromY;
    }
    else{
      processingY = (1 - percentage) * (fromY - toY) + toY;
    }

    if(fromZ < toZ){
      processingZ = percentage * (toZ - fromZ) + fromZ;
    }
    else{
      processingZ = (1 - percentage) * (fromZ - toZ) + toZ;
    }
    let processingScale = processingX + "," + processingY + "," + processingZ;
    element.style.transform = "scale3d(" + processingScale + ")"
  }
}

export function setActualScale(element, scale){
  if(element != null){
    let scaleData = scale.split(" ");
    let scaleX = parseFloat(scaleData[0]);
    let scaleY = parseFloat(scaleData[1]);
    let scaleZ = parseFloat(scaleData[2]);
    element.style.transform = "scale3d("+scaleX+","+scaleY+","+scaleZ+")";
  }
}

export function setTransform(element, translate3dFrom, translate3dTo, percentage){
  if(element != null){
    let translate3dFromData = translate3dFrom.split(" ");let translate3dToData = translate3dTo.split(" ");
    let translate3dFromX = parseFloat(translate3dFromData[0]);
    let translate3dFromY = parseFloat(translate3dFromData[1]);
    let translate3dFromZ = parseFloat(translate3dFromData[2]);
    let translate3dToX = parseFloat(translate3dToData[0]);let translate3dToY = parseFloat(translate3dToData[1]);let translate3dToZ = parseFloat(translate3dToData[2]);

    let processingTranslate3dX = translate3dFromX;
    let processingTranslate3dY = translate3dFromY;
    let processingTranslate3dZ = translate3dFromZ;

    if(translate3dFromX < translate3dToX){
      processingTranslate3dX = percentage * (translate3dToX - translate3dFromX) + translate3dFromX;
    }
    else{
      processingTranslate3dX = (1 - percentage) * (translate3dFromX - translate3dToX) + translate3dToX;
    }
    if(translate3dFromY < translate3dToY){
      processingTranslate3dY = percentage * (translate3dToY - translate3dFromY) + translate3dFromY;
    }
    else{
      processingTranslate3dY = (1 - percentage) * (translate3dFromY - translate3dToY) + translate3dToY;
    }
    if(translate3dFromZ < translate3dToZ){
      processingTranslate3dZ = percentage * (translate3dToZ - translate3dFromZ) + translate3dFromZ;
    }
    else{
      processingTranslate3dZ = (1 - percentage) * (translate3dFromZ - translate3dToZ) + translate3dToZ;
    }

    let processingTranslate3d = processingTranslate3dX + "%" + "," + processingTranslate3dY + "%" + "," + processingTranslate3dZ;
    element.style.transform = "translate3d("+processingTranslate3d+")";
  }
}

export function setActualTransform(element, translate3d){
  if(element != null){
    let translate3dData = translate3d.split(" ");
    let translate3dX = parseFloat(translate3dData[0]);
    let translate3dY = parseFloat(translate3dData[1]);
    let translate3dZ = parseFloat(translate3dData[2]);
    let processingTranslate3d = translate3dX + "%" + "," + translate3dY + "%" + "," + translate3dZ;
    element.style.transform = "translate3d("+processingTranslate3d+")";
  }
}

export function setTransformScale(element, scaleFrom, scaleTo, translate3dFrom, translate3dTo, percentage){
  if(element != null){
    let scaleFromData = scaleFrom.split(" ");let scaleToData = scaleTo.split(" ");
    let scaleFromX = parseFloat(scaleFromData[0]);
    let scaleFromY = parseFloat(scaleFromData[1]);
    let scaleFromZ = parseFloat(scaleFromData[2]);
    let scaleToX = parseFloat(scaleToData[0]);let scaleToY = parseFloat(scaleToData[1]);let scaleToZ = parseFloat(scaleToData[2]);

    let processingScaleX = scaleFromX;
    let processingScaleY = scaleFromY;
    let processingScaleZ = scaleFromZ;

    if(scaleFromX < scaleToX){
      processingScaleX = percentage * (scaleToX - scaleFromX) + scaleFromX;
    }
    else{
      processingScaleX = (1 - percentage) * (scaleFromX - scaleToX) + scaleToX;
    }
    if(scaleFromY < scaleToY){
      processingScaleY = percentage * (scaleToY - scaleFromY) + scaleFromY;
    }
    else{
      processingScaleY = (1 - percentage) * (scaleFromY - scaleToY) + scaleToY;
    }
    if(scaleFromZ < scaleToZ){
      processingScaleZ = percentage * (scaleToZ - scaleFromZ) + scaleFromZ;
    }
    else{
      processingScaleZ = (1 - percentage) * (scaleFromZ - scaleToZ) + scaleToZ;
    }
    let processingScale = processingScaleX + "," + processingScaleY + "," + processingScaleZ;
    //console.log(processingScale);

    let translate3dFromData = translate3dFrom.split(" ");let translate3dToData = translate3dTo.split(" ");
    let translate3dFromX = parseFloat(translate3dFromData[0]);
    let translate3dFromY = parseFloat(translate3dFromData[1]);
    let translate3dFromZ = parseFloat(translate3dFromData[2]);
    let translate3dToX = parseFloat(translate3dToData[0]);let translate3dToY = parseFloat(translate3dToData[1]);let translate3dToZ = parseFloat(translate3dToData[2]);

    //console.log(translate3dFromY + " " + translate3dToY)

    let processingTranslate3dX = translate3dFromX;
    let processingTranslate3dY = translate3dFromY;
    let processingTranslate3dZ = translate3dFromZ;

    if(translate3dFromX < translate3dToX){
      processingTranslate3dX = percentage * (translate3dToX - translate3dFromX) + translate3dFromX;
    }
    else{
      processingTranslate3dX = (1 - percentage) * (translate3dFromX - translate3dToX) + translate3dToX;
    }
    if(translate3dFromY < translate3dToY){
      processingTranslate3dY = percentage * (translate3dToY - translate3dFromY) + translate3dFromY;
    }
    else{
      processingTranslate3dY = (1 - percentage) * (translate3dFromY - translate3dToY) + translate3dToY;
    }
    if(translate3dFromZ < translate3dToZ){
      processingTranslate3dZ = percentage * (translate3dToZ - translate3dFromZ) + translate3dFromZ;
    }
    else{
      processingTranslate3dZ = (1 - percentage) * (translate3dFromZ - translate3dToZ) + translate3dToZ;
    }

    let processingTranslate3d = processingTranslate3dX + "%" + "," + processingTranslate3dY + "%" + "," + processingTranslate3dZ;
    element.style.transform = "translate3d("+processingTranslate3d+") scale3d("+processingScale+")";
  }
}

export function setActualTransformScale(element,  scale, transslate3d){
  if(element != null){
    element.style.transform = "translate3d("+transslate3d+") scale3d("+scale+")";;
  }
}


export function setBlur(element, from, to, percentage){
  if(element != null){
    let processingBlur = 0;
    if(from < to){
      processingBlur = percentage * (to - from) + from;
    }
    else{
      processingBlur = (1- percentage) * (from - to) + to;
    }
    element.style.filter = "blur("+processingBlur+"px)";
  }
}

export function setActualBlur(element, blur){
  if(element != null){
    element.style.filter = "blur("+blur+"px)";
  }
}



export function setOpacity(element, from, to, percentage,unit,roundUp = 10){
  if(element != null){
    let processingOpacity = 0;
    if(from < to){
      processingOpacity = percentage * (to - from) + from;
    }
    else{
      processingOpacity = (1- percentage) * (from - to) + to;
      
    }

    processingOpacity = Math.round(processingOpacity * roundUp) / roundUp;

    
    // if(element.id == "boxPanel1LastSceneOtherSide"){
    //   console.log(processingOpacity);
    // }
    // console.log(processingOpacity);

    element.style.opacity = processingOpacity;
    if(processingOpacity < 0.001){
      element.style.display = "none";
    }
    else{
      element.style.display = "block";
    }
  }
}

export function setActualOpacity(element , opacity){
  if(element != null){
    element.style.opacity = opacity;
    if(opacity < 0.001){
      element.style.display = "none";
    }
    else{
      element.style.display = "block";
    }
  }
}


export function setBackgroundColor(element, fromColor, toColor, percentage){
  if(element != null){
    let processingR = 0;
    if(fromColor["r"] < toColor["r"]){
      processingR = percentage * (toColor["r"] - fromColor["r"]) + fromColor["r"];
    }
    else{
      processingR = (1- percentage) * (fromColor["r"] - toColor["r"]) + toColor["r"];
    }

    let processingG = 0;
    if(fromColor["g"] < toColor["g"]){
      processingG = percentage * (toColor["g"] - fromColor["g"]) + fromColor["g"];
    }
    else{
      processingG = (1- percentage) * (fromColor["g"] - toColor["g"]) + toColor["g"];
    }

    let processingB = 0;
    if(fromColor["b"] < toColor["b"]){
      processingB = percentage * (toColor["b"] - fromColor["b"]) + fromColor["b"];
    }
    else{
      processingB = (1- percentage) * (fromColor["b"] - toColor["b"]) + toColor["b"];
    }

    let processingA = 0;
    if(fromColor["a"] < toColor["a"]){
      processingA = percentage * (toColor["a"] - fromColor["a"]) + fromColor["a"];
    }
    else{
      processingA = (1- percentage) * (fromColor["a"] - toColor["a"]) + toColor["a"];
    }

    element.style.backgroundColor = "rgba("+processingR+","+processingG+","+processingB+","+processingA+")";
  }
}

export function setActualBackgroundColor(element, color){
  if(element != null){
    element.style.backgroundColor = "rgba("+color["r"]+","+color["g"]+","+color["b"]+","+color["a"]+")";
  }
}



export function setBackgroundColorTransparent(element, r,g,b, fromA, toA, percentage){
  if(element != null){
    let processingA = 0;
    if(fromA < toA){
      processingA = percentage * (toA - fromA) + fromA;
    }
    else{
      processingA = (1- percentage) * (fromA - toA) + toA;
    }

    element.style.backgroundColor = "rgba("+r+","+g+","+b+","+processingA+")";
  }
}

export function setActualBackgroundColorTransparent(element, r,g,b,a){
  if(element != null){
    element.style.backgroundColor = "rgba("+r+","+g+","+b+","+a+")";
  }
}

export function setRotation(element, from , to , percentage, unit = "deg", roundUp){
  unit = "deg";
  let processingRotation;
  if(element != null){
    if(from < to){
      processingRotation = percentage * (to - from) + from;
      //element.style.transform = "rotate(" +   Math.round(percentage * (to - from) + from) + unit   + ")";
    }
    else{
      processingRotation = (1- percentage) * (from - to) + to;
      //element.style.transform = "rotate(" +   Math.round((1- percentage) * (from - to) + to) + unit   + ")";
    }

    processingRotation = Math.round(processingRotation * roundUp) / roundUp;

    element.style.transform = "rotate(" +  processingRotation + unit   + ")";
  }
}

export function setActualRotation(element, rotation, unit = "deg"){
  if(element != null){
    element.style.transform = "rotate(" + rotation + unit   + ")";
  }
}

export function setRotationCenter(element, from , to , percentage, unit = "deg"){
  if(element != null){
    if(from < to){
      element.style.transform = "translate(-50%,-50%) rotate(" +   Math.round(percentage * (to - from) + from) + unit   + ")";
    }
    else{
      element.style.transform = "translate(-50%,-50%) rotate(" +   Math.round((1- percentage) * (from - to) + to) + unit   + ")";
    }
  }
}

export function setActualRotationCenter(element, rotation, unit = "deg"){
  if(element != null){
    element.style.transform = "translate(-50%,-50%) rotate(" + rotation + unit   + ")";
  }
}

export function getTranslate3d (el) {
  var values = el.style.transform.split(/\w+\(|\);?/);
  if (!values[1] || !values[1].length) {
      return [];
  }
  return values[1].split(/,\s?/g);
}


// WEBPACK FOOTER //
// ./src/commonFunction/commonFunction.js